export const hostilitesValues = [
    { id: 'مقیم', value: 'Hostelite' },
    { id: 'غیرمقیم', value: 'Non-Hostelite' },
];

export const cardDegrees = [
    { id: 'حفظ و ناظرہ قرآن مجید', value: 'Hifz o Nazra' },
    { id: 'تجوید و قرأت', value: 'Tajweed o Qirat' },
    { id: 'درس نظامی', value: 'Darse Nizami' },
    { id: 'دورہ حدیث شریف', value: 'Dorae Hadees' },
];

export const hostilites = ['غیراقامتی', 'اقامتی'];

export const bloodGroups = ['+A', '-A', '+B', '-B', '+O', '-O', '+AB', '-AB'];

export const feesVariants = ['ریگولر', 'لیٹ'];

export const statesInUrdu = [
    'پنجاب',
    'آزاد کشمیر',
    'بلوچستان',
    'سندھ',
    'خیبر پختونخوا',
    'گلگت بلتستان',
];

export const citiesInUrdu = [
    'کراچی',
    'لاہور',
    'فیصل آباد',
    'راولپنڈی',
    'گوجرانوالہ',
    'پشاور',
    '	ملتان',
    'حیدرآباد، سندھ',
    'اسلام آباد',
    '	کوئٹہ',
    'بہاولپور',
    'سرگودھا',
    '	سیالکوٹ',
    '	سکھر',
    '	لاڑکانہ',
    '	شیخوپورہ',
    '	رحیم یار خان',
    '	جھنگ',
    'ڈیرہ غازی خان',
    '	گجرات (پاکستان)',
    '	ساہیوال',
    '	واہ کینٹ',
    '	مردان',
    'قصور',
    '	اوکاڑہ',
    '	مینگورہ',
    'نوابشاہ',
    'چنیوٹ',
    '	کوٹری',
    '	کامونکی',
    'حافظ آباد',
    'صادق آباد، پاکستان',
    'میرپور خاص',
    '	بورے والا',
    '	کوہاٹ',
    '	خانیوال',
    'ڈیرہ اسماعیل خان',
    '	تربت',
    '	مظفر گڑھ',
    '	ایبٹ آباد',
    'منڈی بہاؤالدین',
    '	شکارپور، پاکستان',
    'جیکب آباد',
    'جہلم',
    '	خان پور',
    '	خیرپور',
    '	خضدار',
    '	پاکپتن',
    '	حب، بلوچستان',
    'ڈسکہ',
    '	گوجرہ',
    '	دادو',
    'مریدکے',
    'بہاولنگر',
    'سمندری',
    '	ٹنڈو الہ یار',
    '	ٹنڈو آدم',
    'جڑانوالہ',
    '	چشتیاں',
    '	اٹک',
    '	وہاڑی',
    '	کوٹ عبدالمالک',
    '	فیروزوالا',
    'چکوال',
    '	کمالیہ',
    '	عمرکوٹ',
    'احمد پور شرقیہ',
    '	کوٹ ادو',
    '	وزیر آباد',
    '	مانسہرہ',
    '	لیہ',
    'صوابی',
    'چمن',
    'ٹیکسلا شہر',
    'نوشہرہ (خیبر پختونخوا)',
    'خوشاب',
    'شہدادکوٹ',
    'میانوالی',
    '	کبل، سوات',
    '	لودهراں',
    'حاصل پور',
    '	چارسدہ',
    'بھکر',
    'بدین',
    'عارف والا',
    '	گھوٹکی',
    'سمبڑیال',
    'جتوئی، پاکستان',
    'ہارون آباد، بہاولنگر',
    'ڈھرکی',
    'نارووال',
    'ٹنڈو محمد خان',
    'میرپور ماتھیلو',
    'كندھ كوٹ',
    '	بھلوال',
];

export const branches = [
    { name: 'جامعہ نظامیہ رضویہ، لاہور', code: '01' },
    { name: 'جامعہ نظامیہ رضویہ، شیخوپورہ', code: '02' },
];

export const districtsInUrdu = [
    'لاہور',
    'شیخوپورہ',
    'قصور',
    'گوجرانوالہ',
    'مظفر گڑھ',
    'ڈیرہ غازی خان',
    'گجرات',
    'حافظ آباد',
    'جھنگ',
    'جہلم',
    'فیصل آباد',
    'خانیوال',
    'خوشاب',
    'لیہ',
    'اٹک',
    'بہاولنگر',
    'بہاولپور',
    'بھکر',
    'چکوال',
    'چنیوٹ',
    'لودھراں',
    'منڈی بہاوالدین',
    'میانوالی',
    'ملتان',
    'نارووال',
    'ننکانہ صاحب',
    'اوکاڑہ',
    'پاکپتن',
    'رحیم یار خان',
    'راجن پور',
    'راولپنڈی',
    'اسلام آباد',
    'ساہیوال',
    'سرگودھا',
    'سیالکوٹ',
    'ٹوبہ ٹیک سنگھ',
    'وہاڑی',
    'مظفر آباد',
    'ہٹیاں بالا',
    'نیلم',
    'آزاد کشمیر میر پور',
    'بھمبر',
    'کوٹلی',
    'پونچھ',
    ' باغ',
    ' حویلی',
    ' سدھنوتی',
    'آواران',
    'بارخان',
    'بولان',
    'چاغی',
    'ڈیرہ بگٹی',
    'گوادر',
    'ہرنائی',
    'جعفر آباد',
    'جھل مگسی',
    'قلات',
    'کیچ',
    'خاران',
    'کوہلو',
    'خضدار',
    'قلعہ عبداللہ',
    'قلعہ سیف اللہ',
    'لسبیلہ',
    'لورالائی',
    'مستونگ',
    'موسیٰ خیل',
    'نصیر آباد',
    'نوشکی',
    'پنجگور',
    'پشین',
    'کوئٹہ',
    'شیرانی',
    'سبی',
    'واشک',
    'ژوب',
    'زیارت',
    'بدین',
    'دادو',
    ' گھوٹکی',
    'حیدرآباد، سندھ',
    'جیکب آباد',
    'جامشورو',
    'کراچی',
    'کشمور',
    'خیرپور',
    'لاڑکانہ',
    'مٹیاری',
    'میرپور خاص',
    'نوشہرو فیروز',
    'نوابشاہ',
    'قمبر',
    'سانگھڑ',
    'شکارپور',
    'سکھر',
    'ٹنڈو الہ یار',
    'ٹنڈو محمد خان',
    'تھرپارکر',
    'ٹھٹہ',
    'عمرکوٹ',
    'سجاول',
    ' کراچی وسطی',
    ' کراچی شرقی',
    ' کراچی جنوبی',
    ' کراچی غربی',
    'کورنگی',
    'ملیر',
    'ایبٹ آباد',
    'بنوں',
    'بٹگرام',
    'بونیر',
    'چارسدہ',
    'چترال',
    'ڈیرہ اسماعیل خان',
    'ہنگو',
    'ہری پور',
    'کرک',
    'کوہاٹ',
    'کوہستان',
    'لکی مروت',
    'دیر زیریں',
    'مالاکنڈ',
    'مانسہرہ',
    'مردان',
    'نوشہرہ',
    'پشاور',
    'شانگلہ',
    'صوابی',
    'سوات',
    'ٹانک',
    'تور غر',
    'دیر بالا',
    'استور',
    'دیامر',
    'غذر',
    'گانچھے',
    'گلگت',
    'ہنزہ نگر',
    'وادی کھرمنگ',
    'ضلع سکردو',
    'شگر',
];

export const allDistricts = {
    punjab: [
        'لاہور',
        'شیخوپورہ',
        'قصور',
        'گوجرانوالہ',
        'مظفر گڑھ',
        'ڈیرہ غازی خان',
        'گجرات',
        'حافظ آباد',
        'جھنگ',
        'جہلم',
        'فیصل آباد',
        'خانیوال',
        'خوشاب',
        'لیہ',
        'اٹک',
        'بہاولنگر',
        'بہاولپور',
        'بھکر',
        'چکوال',
        'چنیوٹ',
        'لودھراں',
        'منڈی بہاوالدین',
        'میانوالی',
        'ملتان',
        'نارووال',
        'ننکانہ صاحب',
        'اوکاڑہ',
        'پاکپتن',
        'رحیم یار خان',
        'راجن پور',
        'راولپنڈی',
        'اسلام آباد',
        'ساہیوال',
        'سرگودھا',
        'سیالکوٹ',
        'ٹوبہ ٹیک سنگھ',
        'وہاڑی',
    ],
    azadKashmir: [
        'مظفر آباد',
        'ہٹیاں بالا',
        'نیلم',
        'آزاد کشمیر میر پور',
        'بھمبر',
        'کوٹلی',
        'پونچھ',
        ' باغ',
        ' حویلی',
        ' سدھنوتی',
    ],
    blochistan: [
        'آواران',
        'بارخان',
        'بولان',
        'چاغی',
        'ڈیرہ بگٹی',
        'گوادر',
        'ہرنائی',
        'جعفر آباد',
        'جھل مگسی',
        'قلات',
        'کیچ',
        'خاران',
        'کوہلو',
        'خضدار',
        'قلعہ عبداللہ',
        'قلعہ سیف اللہ',
        'لسبیلہ',
        'لورالائی',
        'مستونگ',
        'موسیٰ خیل',
        'نصیر آباد',
        'نوشکی',
        'پنجگور',
        'پشین',
        'کوئٹہ',
        'شیرانی',
        'سبی',
        'واشک',
        'ژوب',
        'زیارت',
    ],
    sindh: [
        'بدین',
        'دادو',
        ' گھوٹکی',
        'حیدرآباد، سندھ',
        'جیکب آباد',
        'جامشورو',
        'کراچی',
        'کشمور',
        'خیرپور',
        'لاڑکانہ',
        'مٹیاری',
        'میرپور خاص',
        'نوشہرو فیروز',
        'نوابشاہ',
        'قمبر',
        'سانگھڑ',
        'شکارپور',
        'سکھر',
        'ٹنڈو الہ یار',
        'ٹنڈو محمد خان',
        'تھرپارکر',
        'ٹھٹہ',
        'عمرکوٹ',
        'سجاول',
        ' کراچی وسطی',
        ' کراچی شرقی',
        ' کراچی جنوبی',
        ' کراچی غربی',
        'کورنگی',
        'ملیر',
    ],
    khabarPakhtonKhawan: [
        'ایبٹ آباد',
        'بنوں',
        'بٹگرام',
        'بونیر',
        'چارسدہ',
        'چترال',
        'ڈیرہ اسماعیل خان',
        'ہنگو',
        'ہری پور',
        'کرک',
        'کوہاٹ',
        'کوہستان',
        'لکی مروت',
        'دیر زیریں',
        'مالاکنڈ',
        'مانسہرہ',
        'مردان',
        'نوشہرہ',
        'پشاور',
        'شانگلہ',
        'صوابی',
        'سوات',
        'ٹانک',
        'تور غر',
        'دیر بالا',
    ],
    gilgitBaltistan: [
        'استور',
        'دیامر',
        'غذر',
        'گانچھے',
        'گلگت',
        'ہنزہ نگر',
        'وادی کھرمنگ',
        'ضلع سکردو',
        'شگر',
    ],
};

export const leavingIntituteRessons = ['مزید تعلیم', 'کوئی نہیں'];

export const degrees = ['حفظ و ناظرہ قرآن مجید', 'تجوید و قرأت', 'درس نظامی', 'دورہ حدیث شریف'];

export const departments = ['حفظ و ناظرہ قرآن مجید', 'تجوید و قرأت', 'درس نظامی'];

export const UrlPaths = {
    Register: '/register',
    Login: '/login',
    Applicants: '/dashboard/applicants',
};
